'use client';

import dynamic from 'next/dynamic';

const FirebaseLoginRedirectHandler = dynamic(() => import('@/components/firebase-login-redirect-handler'), {
    ssr: false,
});

const FacebookOAuthHashHandler = dynamic(() => import('@/components/facebook-oauth-hash-handler'), {
    ssr: false,
});

/**
 * OAuth 回跳 Handler 的延迟挂载入口，仅负责 dynamic 引入与渲染。
 * - Firebase / Facebook：dynamic 分包（ssr: false），具体回跳逻辑在各自组件内处理
 */
export default function DeferredRootHandlers() {
    return (
        <>
            <FirebaseLoginRedirectHandler />
            <FacebookOAuthHashHandler />
        </>
    );
}
